import { createSlice } from '@reduxjs/toolkit';
import { IInitialAllReportsListState, IReportSettings } from './types';

const SLICE_NAME = 'AUTOMATED_REPORTS_SLICE';

export const initialState: IInitialAllReportsListState = {
  loading: false,
  issuesLoading: false,
  specificIssuesLoading: false,
  dashboardLoading: false,
  settingsLoading: false,
  error: '',
  allReports: [],
  latestReport: [],
  latestReportGrouped: [],
  specificReport: [],
  specificReportGrouped: [],
  latestDashboard: null,
  specificDashboard: null,
  reportSettings: {} as IReportSettings,
  isGrouping: false,
  pageTotal: 0,
  totalIssuesCount: 0,
  status: null,
  statusLoading: false,
  totalReports: 0,
  resolvedReports: 0,
  auditEngines: null,
  engine: null,
  auditLenght:null,
  mapData : null,
  reportId : null,
  trackingNumber : null,
  LoadingageAudit : false,
  pageAudit : null,
  pageAuditError : "",
  updated:false
};

const automatedReportsSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    fetchAllReportsError: (state) => {
      state.loading = false;
      state.error = 'error';
    },
    fetchAllReports: (state, { payload }) => {
      state.loading = true;
      state.error = '';
    },
    fetchAllReportsSuccess: (state, { payload }) => {
      state.loading = false;
      state.allReports = payload;
    },
    fetchLatestReportError: (state) => {
      state.issuesLoading = false;
      state.error = 'error';
      state.latestReport = [];
      state.pageTotal = 0;
      state.totalIssuesCount = 0;
    },
    fetchLatestReport: (state, { payload }) => {
      state.issuesLoading = true;
      state.error = '';
    },
    fetchLatestReportSuccess: (state, { payload }) => {
      state.issuesLoading = false;
      state.isGrouping = false;
      state.latestReport = payload.issues;
      state.pageTotal = payload.pageTotal;
      state.totalIssuesCount = payload.totalIssuesCount;
      state.engine = payload.engine;
      state.mapData = payload.mapData;
      state.reportId = payload.reportId;
      state.trackingNumber = payload.trackingNumber
    },
    fetchLatestDashboardError: (state) => {
      state.dashboardLoading = false;
      state.error = 'error';
    },
    fetchLatestDashboard: (state, { payload }) => {
      state.dashboardLoading = true;
      state.error = '';
    },
    fetchLatestDashboardSuccess: (state, { payload }) => {
      state.dashboardLoading = false;
      state.latestDashboard = payload;
    },
    fetchReportSettingsError: (state) => {
      state.settingsLoading = false;
      state.error = 'error';
    },
    fetchReportSettings: (state, { payload }) => {
      state.settingsLoading = true;
      state.error = '';
    },
    fetchReportSettingsSuccess: (state, { payload }) => {
      state.settingsLoading = false;
      state.reportSettings = payload;
    },
    updateReportSettingsError: (state , { payload }) => {
      state.settingsLoading = false;
      state.error = payload ?? "error";
      state.updated = false;
    },
    _updateReportSettingsState : (state) => {
      state.settingsLoading = false;
      state.error = "",
      state.updated = false;

    },
    updateReportSettings: (state, { payload }) => {
      state.settingsLoading = true;
      state.error = '';
    },
    updateReportSettingsSuccess: (state, { payload }) => {
      state.settingsLoading = false;
      state.reportSettings.frequency = payload.site.frequency;
      state.reportSettings.compliance_level = payload.site.engine.compliance_level;
      state.reportSettings.notifications = payload.site.notifications;
      state.reportSettings.name = payload.site.engine.name;
      state.reportSettings.engine_id = payload.site.engine.id;
      state.reportSettings.jsCode = payload?.site?.jsCode
      state.updated = true;
    },
    fetchSpecificReportError: (state) => {
      state.specificIssuesLoading = false;
      state.error = 'The specified key does not exist';
      state.mapData = null;
    },
    fetchSpecificReport: (state, { payload }) => {
      state.specificIssuesLoading = true;
      state.error = '';
    },
    fetchSpecificReportSuccess: (state, { payload }) => {
      state.specificIssuesLoading = false;
      state.isGrouping = false;
      state.specificReport = payload.issues;
      state.latestReport = payload.issues;
      state.pageTotal = payload.pageTotal;
      state.totalIssuesCount = payload.totalIssuesCount;
      state.engine = payload.engine ? payload.engine : state.engine;
      state.mapData = payload.mapData;
      state.reportId = payload.reportId;
    },
    fetchSpecificDashboardError: (state) => {
      state.loading = false;
      state.error = 'The specified key does not exist';
    },
    fetchSpecificDashboard: (state, { payload }) => {
      state.loading = true;
      state.error = '';
    },
    fetchSpecificDashboardSuccess: (state, { payload }) => {
      state.loading = false;
      state.specificDashboard = payload;
    },

    fetchLatestReportByGroupError: (state) => {
      state.loading = false;
      state.error = 'error';
    },
    fetchLatestReportByGroup: (state, { payload }) => {
      state.loading = true;
      state.error = '';
      state.latestReportGrouped = [];
      state.pageTotal = 0;
      state.totalIssuesCount = 0;
    },
    fetchLatestReportByGroupSuccess: (state, { payload }) => {
      state.loading = false;
      state.isGrouping = true;
      state.latestReportGrouped = payload.issues;
      state.pageTotal = payload.pageTotal;
      state.totalIssuesCount = payload.totalIssuesCount;
      state.engine = payload.engine;
    },

    fetchSpecificReportByGroupError: (state) => {
      state.specificIssuesLoading = false;
      state.error = 'error';
    },
    fetchSpecificReportByGroup: (state, { payload }) => {
      state.specificIssuesLoading = true;
      state.error = '';
    },
    fetchSpecificReportByGroupSuccess: (state, { payload }) => {
      state.specificIssuesLoading = false;
      state.isGrouping = true;
      state.specificReportGrouped = payload.issues;
      state.pageTotal = payload.pageTotal;
      state.totalIssuesCount = payload.totalIssuesCount;
      state.engine = payload.engine;
    },

    runAutomatedAuditError: (state ,payload) => {
      state.loading = false;
      state.error = payload.payload;
    },
    runAutomatedAudit: (state, { payload }) => {
      state.loading = true;
    },
    runAutomatedAuditSuccess: (state, { payload }) => {
      state.loading = false;
      state.error = '';
    },
    automatedAuditStatusError: (state) => {
      state.statusLoading = false;
      state.error = 'error';
    },
    automatedAuditStatus: (state, { payload }) => {
      state.statusLoading = true;
    },
    automatedAuditStatusSuccess: (state, { payload }) => {
      const statusProgress = payload.status.split('%')[0];
      state.statusLoading = isNaN(statusProgress) || Number(statusProgress) < 100 ? true : false;
      state.status = payload;
      state.error = '';
    },

    fetchLatestReportRetry: (state, { payload }) => {
      state.issuesLoading = true;
      state.error = '';
    },
    fetchAuditEngine: (state) => {
      state.error = '';
    },
    fetchAuditEngineSuccess: (state, { payload }) => {
      state.auditEngines = payload;
      state.error = '';
    },
    fetchAuditEngineError: (state) => {
      state.error = '';
    },
    setDefault: () => {
      return initialState;
    },
    fetchTotalReportsError: (state) => {
      state.loading = false;
      state.error = 'error';
    },
    fetchTotalReports: (state) => {
      state.loading = true;
      state.error = '';
    },
    fetchTotalReportsSuccess: (state, { payload }) => {
      state.loading = false;
      state.totalReports = payload;
    },
    fetchResolvedReportsError: (state) => {
      state.loading = false;
      state.error = 'error';
    },
    fetchResolvedReports: (state) => {
      state.loading = true;
      state.error = '';
    },
    fetchResolvedReportsSuccess: (state, { payload }) => {
      state.loading = false;
      state.resolvedReports = payload;
    },
    fetchAuditLenghtError: (state) => {
      state.loading = false;
      state.error = 'error';
    },
    fetchAuditLenght: (state,{ payload }) => {
      state.loading = true;
      state.error = '';
    },
    fetchAuditLenghtSuccess: (state, { payload }) => {
      state.loading = false;
      state.auditLenght = payload;
    },
    singlePageAuditError: (state , { payload}) => {
      state.loading = false;
      state.pageAuditError = payload;
    },
    singlePageAudit: (state,{ payload }) => {
      state.LoadingageAudit = true;
      state.pageAuditError = '';
    },
    singlePageAuditSuccess: (state, { payload }) => {
      state.LoadingageAudit = false;
      state.pageAudit = payload;
    },
    // re audit
    reauditCriteriaPagesError: (state , { payload}) => {
      state.loading = false;
      state.pageAuditError = payload;
    },
    reauditCriteriaPages: (state,{ payload }) => {
      state.LoadingageAudit = true;
      state.pageAuditError = '';
    },
    reauditCriteriaPagesSuccess: (state, { payload }) => {
      state.LoadingageAudit = false;
      state.pageAudit = payload;
    }
  },
});

export default automatedReportsSlice;
